<template>
  <div>
    <h4 class="ui dividing header">{{ $t("configured notifications") }}</h4>
    <div class="ui icon message" v-if="!notifications || !notifications.length">
      <i class="exclamation orange triangle icon"></i>
      <div class="content">
        <div class="header">
          {{ $t("no notifications configured yet") }}
        </div>
      </div>
    </div>
    <div class="ui relaxed selection list">
      <div
        class="item"
        v-for="(notification, index) in notifications"
        :key="index"
        @click="edit(notification)"
      >
        <div
          class="ui red right floated icon mini button"
          @click.stop="remove(notification, index)"
        >
          <i class="trash icon"></i>
        </div>
        <i
          class="large middle aligned icon"
          v-bind:class="{
            at: notification.type == 'email',
            envelope: notification.type == 'sms',
          }"
        ></i>
        <div class="content">
          <a>
            {{ $t("send outbox template") }}
            <b>{{ notification.outbox_template_name }}</b>
            {{ $t("on task event") }}
            <b>{{ $t(notification.event) }}</b>
          </a>
          <div class="description" v-if="setup.type == 'email'">
            {{ notification.title }}
          </div>
          <div class="description" v-if="setup.type == 'sms'">
            {{ notification.sms_message }}
          </div>
        </div>
      </div>
    </div>
    <div class="ui divider"></div>
    <div class="two fields">
      <div class="field">
        <label for>{{ $t("notify at task") }}</label>
        <select class="ui dropdown" ref="event_dropdown" v-model="setup.event">
          <option value>{{ $t("select one") }}</option>
          <option :value="evt.value" v-for="(evt, idx) in events" :key="idx">{{
            evt.display
          }}</option>
        </select>
      </div>
      <div class="field" v-show="false">
        <label for>{{ $t("notification type") }}</label>
        <select class="ui dropdown" ref="type_dropdown" v-model="setup.type">
          <option value>{{ $t("select one") }}</option>
          <!-- <option value="sms">{{ $t("sms") }}</option> -->
          <option value="email">{{ $t("email") }}</option>
        </select>
      </div>
      <div class="field">
        <label for>{{ $t("outbox template") }}</label>
        <select class="ui dropdown" ref="outbox_template_dropdown"> </select>
      </div>
    </div>
    <div class="field">
      <label for>{{ $t("recipients") }}</label>
      <input type="text" name="recipients" v-model="setup.recipients" />
    </div>
    <!-- <div class="field" v-if="setup.type == 'email'">
      <label for>{{ $t("title") }}</label>
      <input type="text" name="title" v-model="setup.title" />
    </div>
    <div class="field" v-bind:class="{ hidden: setup.type != 'sms' }">
      <label for>{{ $t("message") }}</label>
      <textarea
        name="sms_message"
        rows="2"
        v-model="setup.sms_message"
      ></textarea>
    </div> -->
    <div class="field">
      <div class="ui info message" style="display: block">
        <div class="header">{{ $t("hints") }}</div>
        <ul class="list">
          <li v-html="$t('use D to refer data objects')"></li>
          <li v-html="$t('use ${interact_url} to refer the task link')"></li>
        </ul>
      </div>
      <label for>{{ $t("template arguments") }}</label>
      <editor
        @init="init_editor"
        v-model="setup.input_arguments"
        lang="json"
        theme="monokai"
      ></editor>
    </div>
    <div class="field" v-if="setup.type == 'email'">
      <label for>{{ $t("attachments") }}</label>
      <input type="text" name="attachments" v-model="setup.attachments" />
    </div>
    <div class="ui basic icon labeled button" @click="clear">
      <i class="orange erase icon"></i>
      {{ $t("clear") }}
    </div>
    <div class="ui basic icon labeled button right floated" @click="save">
      <i class="blue save icon"></i>
      {{ $t("save") }}
    </div>
  </div>
</template>

<script>
import { v4 } from "uuid";
import { clone, local_api, error_toast } from "@/utils";
import Editor from "vue2-ace-editor";

export default {
  name: "NotificationManager",
  props: {
    notifications: Array,
    events: Array,
  },
  components: {
    Editor,
  },
  data() {
    return {
      setup: {
        uuid: "",
        event: "",
        outbox_template_id: "",
        outbox_template_name: "",
        recipients: "",
        input_arguments: "",
      },
      template_list: [],
    };
  },
  methods: {
    save() {
      this.setup.uuid = this.setup.uuid || v4();
      let trgtIndex = this.notifications.findIndex(
        (n) => n.uuid == this.setup.uuid,
      );
      console.log(this.setup);
      if (trgtIndex != -1)
        this.notifications.splice(trgtIndex, 1, clone(this.setup));
      else this.notifications.push(clone(this.setup));
      this.clear();
    },
    clear() {
      let vm = this;
      window.jQuery(vm.$refs.outbox_template_dropdown).dropdown("clear");
      window.jQuery(vm.$refs.type_dropdown).dropdown("clear");
      window.jQuery(vm.$refs.event_dropdown).dropdown("clear");
      this.setup = {
        uuid: "",
        event: "",
        outbox_template_id: "",
        outbox_template_name: "",
        recipients: "",
        input_arguments: "",
      };
    },
    remove(notification, index) {
      this.notifications.splice(index, 1);
    },
    edit(notification) {
      let vm = this;
      this.setup = clone(notification);

      window
        .jQuery(vm.$refs.outbox_template_dropdown)
        .dropdown("set selected", notification.outbox_template_id);
      window
        .jQuery(vm.$refs.type_dropdown)
        .dropdown("set selected", notification.type);
      window
        .jQuery(vm.$refs.event_dropdown)
        .dropdown("set selected", notification.event);
    },
    init_editor() {
      require(`brace/mode/json`);
      require("brace/theme/monokai");
    },
  },
  created() {},
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.type_dropdown).dropdown({
      onChange(value) {
        vm.setup.type = value;
      },
    });
    window.jQuery(vm.$refs.event_dropdown).dropdown({
      onChange(value) {
        vm.setup.event = value;
      },
    });

    local_api(vm, "post", "/outbox/template/do-get-list")
      .then((templates) => {
        vm.template_list = templates;
        let vls = templates.map((t) => {
          return { name: t.name, value: t.template_id };
        });
        window
          .jQuery(vm.$refs.outbox_template_dropdown)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            onChange(value, text) {
              vm.setup.outbox_template_id = value;
              vm.setup.outbox_template_name = text;
              let trgt = templates.find((tp) => tp.template_id == value);
              if (trgt) {
                let args = trgt.setup.arguments;
                let oargs = {};
                for (let i = 0; i < args.length; i++) {
                  oargs[args[i].name] = args[i].default_value;
                }
                let xx = JSON.stringify(oargs, null, 2);
                if (args.length) {
                  if (vm.setup.input_arguments) {
                    vm.$alertify.confirm(
                      vm.$t(
                        "do you want to replace current content for default parameters?",
                      ),
                      function() {
                        vm.setup.input_arguments = xx;
                      },
                    );
                  } else {
                    vm.setup.input_arguments = xx;
                  }
                }
              }
            },
          });
      })
      .catch((err) => {
        error_toast(err);
      });
  },
};
</script>
